import { render, staticRenderFns } from "./WebsiteNavigationLink.vue?vue&type=template&id=6593aa61"
import script from "./WebsiteNavigationLink.vue?vue&type=script&lang=ts"
export * from "./WebsiteNavigationLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports